export const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="28">
    <g fill="none" fill-rule="nonzero">
      <path
        fill="#3D3A3B"
        d="M2.46327722 19.063383L19.90195533 1.62470487l8.784898 8.784898L11.24817522 27.848281z"
        opacity="0.15"
      ></path>
      <path
        fill="#3D3A3B"
        d="M19.75854796 10.82599175l8.784898-8.784898 17.43867812 17.43867812-8.784898 8.784898z"
        opacity="0.25"
      ></path>
      <path
        fill="#3D3A3B"
        d="M19.86557152 37.05314013L37.30424963 19.614462l8.784898 8.784898-17.43867811 17.43867812z"
        opacity="0.25"
      ></path>
      <path
        fill="#3D3A3B"
        d="M2.04960266 28.41855201l8.784898-8.784898 17.43867812 17.43867812-8.784898 8.784898z"
        opacity="0.15"
      ></path>
      <g>
        <circle cx="24.0364238" cy="6.30463576" r="6.25827815" fill="#3D3A3B"></circle>
        <circle cx="41.6986755" cy="24.0364238" r="6.25827815" fill="#3D3A3B"></circle>
        <circle cx="24.0364238" cy="41.6986755" r="6.25827815" fill="#3D3A3B"></circle>
        <circle cx="6.37417219" cy="23.9668874" r="6.25827815" fill="#3D3A3B"></circle>
      </g>
    </g>
  </svg>
);
